module.exports = __webpack_public_path__ + "static/media/football-t-shirt-with-number-83.c65a848d.svg";